import type { SupportedLocale, TranslationKey } from '@dukanti/shared';
import { useTranslation } from '@dukanti/shared';
import { Button } from '@/components/ui/button';

const LOCALES: readonly SupportedLocale[] = ['ar', 'he', 'en'];

export function PromotionLocaleSelector(props: {
  readonly value: SupportedLocale;
  readonly onChange: (locale: SupportedLocale) => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <fieldset className="space-y-2">
      <legend className="text-foreground text-sm font-medium">
        {t('admin.promotionKit.locale.label' as TranslationKey)}
      </legend>
      <div className="flex flex-wrap gap-2">
        {LOCALES.map((locale) => (
          <Button
            key={locale}
            type="button"
            size="sm"
            variant={props.value === locale ? 'default' : 'outline'}
            aria-pressed={props.value === locale}
            onClick={() => props.onChange(locale)}
          >
            {locale.toUpperCase()}
          </Button>
        ))}
      </div>
    </fieldset>
  );
}
